// Customizable Area Start
import { RouteComponentProps } from "react-router-dom";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { IBlock } from "../../../framework/src/IBlock";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { Message } from "../../../framework/src/Message";
import { NewEveryreelSteps, PostTypes } from "./enums";
import { File, FunnelFileData } from "./types";
import { getToken } from "../../../components/src/AuthService";

export const configJSON = require("./config");

export interface SavedFile {
  id: string;
  type: string;
  attributes: {
    id: number;
    body: any;
    social_videoable_id: any;
    social_videoable_type: string;
    file: {
      model_name: string;
      body: any;
      likes_count: number;
      comments_count: number;
      button_name: any;
      button_url: any;
      file: string;
    };
  };
}

export type Props = RouteComponentProps & {
  id?: string;
  classes?: any;
  navigation: any;
};

interface S {
  currentStep: NewEveryreelSteps;
  error: string;
  files: File[];
  savedFunnelFiles: FunnelFileData[];
  postType?: PostTypes;
  uploadedMediaError: string;
  uploadFunnelFilesLoading: boolean;
  uploadFunnelFilesError: string;
}

interface SS {
  navigation: any;
}

export default class CreateEveryreelController extends BlockComponent<
  Props,
  S,
  SS
> {
  sendFilesApiCallId: string = "";

  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    this.state = {
      currentStep: NewEveryreelSteps.INITIAL_CHOICE,
      files: [],
      savedFunnelFiles: [],
      postType: undefined,
      error: "",
      uploadedMediaError: "",
      uploadFunnelFilesLoading: false,
      uploadFunnelFilesError: "",
    };
  }

  template = configJSON.template;

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<S>): void {
    if (prevState.files !== this.state.files && this.state.files.length) {
      if (this.state.currentStep === NewEveryreelSteps.EVERYREEL_LIBRARY) {
        this.setStep(NewEveryreelSteps.POST_SETTINGS);
      } else {
        this.sendFunnelFiles();
      }
    }
  }
  removeChoice = (choiceIndex: number) => {
    const state: any = this.state;
  
    const selectedFile = state.selectedFile;
    const files = state.files;
  
    if (!selectedFile) return;
  
    const updatedChoices = selectedFile.choices.filter(
      (_: any, index: number) => index !== choiceIndex
    );
  
    const updatedSelectedFile = {
      ...selectedFile,
      choices: updatedChoices,
    };
  
    const updatedFiles = files.map((file: any) => {
      if (
        file.id === selectedFile.id ||
        file.title === selectedFile.title
      ) {
        return {
          ...file,
          choices: updatedChoices,
        };
      }
  
      return file;
    });
  
    this.setState({
      selectedFile: updatedSelectedFile,
      files: updatedFiles,
    } as any);
  };
  closeModal = () => {
    const msg = new Message(getName(MessageEnum.NavigationMessage));
    msg.addData(getName(MessageEnum.NavigationTargetMessage), 'Dashboard');
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  };

  addFiles = (files: File[]) => {
    const MAX_FILES = 15;
    this.setState((prevState) => {
      const currentFileCount = prevState.files.length;
      const newFileCount = files.length;
      const totalFiles = currentFileCount + newFileCount;

      // Check if adding new files would exceed the limit
      if (totalFiles > MAX_FILES) {
        const remainingSlots = MAX_FILES - currentFileCount;
        if (remainingSlots <= 0) {
          // Already at or over limit
          this.setState({ 
            uploadedMediaError: `Maximum ${MAX_FILES} files allowed. Please remove some files before adding new ones.` 
          });
          setTimeout(() => {
            this.setState({ uploadedMediaError: "" });
          }, 5000);
          return null;
        } else {
          // Add only up to the limit
          const filesToAdd = files.slice(0, remainingSlots);
          this.setState({ 
            uploadedMediaError: `Maximum ${MAX_FILES} files allowed. Only ${remainingSlots} file(s) added.` 
          });
          setTimeout(() => {
            this.setState({ uploadedMediaError: "" });
          }, 5000);
          return {
            files: [...prevState.files, ...filesToAdd],
          };
        }
      }

      return {
        files: [...prevState.files, ...files],
      };
    });
  };

  setStep = (step: NewEveryreelSteps) => {
    this.setState({ currentStep: step });
  };

  setFiles = (files: File[]) => {
    const isNotVideo = files.some((file) => {
      const videoMimeValid = file.type.startsWith('video/');
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      const allowedVideoExtensions = ['mp4', 'mov', 'm4v', 'hevc'];
  
      return !(videoMimeValid || allowedVideoExtensions.includes(fileExtension!));
    });
  
    if (isNotVideo) {
      this.setState({ uploadedMediaError: "Only video files are allowed" });
      setTimeout(() => {
        this.setState({ uploadedMediaError: "" });
      }, 5000)
      return;
    }
    this.setState({
      files,
    });
  };

  setPostType = (postType: PostTypes) => {
    this.setState({ postType });
  };

  async receive(_from: string, message: Message) {
    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    if (apiRequestCallId === this.sendFilesApiCallId) {
      this.handleFunnelFilesAPIResponse(message);
    }
  }

  sendFunnelFiles = () => {
    this.setState({ uploadFunnelFilesLoading: true });
    const formData = new FormData()

    this.state.files.forEach((file) => {
      formData.append("files[]", (file as unknown) as Blob);
    })

    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    )

    this.sendFilesApiCallId = requestMessage.messageId
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        token: getToken(),
      })
    )
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.uploadFunnelFilesEndPoint
    )
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.PostAPiMethod
    )

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      formData
    )
    runEngine.sendMessage(requestMessage.id, requestMessage)
    return requestMessage.messageId
  };

  handleFunnelFilesAPIResponse = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson?.data) {
      this.setState({ savedFunnelFiles: responseJson.data, uploadFunnelFilesLoading: false, uploadFunnelFilesError: "" });
      this.setStep(NewEveryreelSteps.POST_SETTINGS);
    } else {
      const errorMsg = responseJson?.errors?.[0]?.message || responseJson?.error || responseJson?.message || "Video(s) exceeds the upload limits";
      this.setState({ uploadFunnelFilesLoading: false, uploadFunnelFilesError: errorMsg });
    }
  };
}
// Customizable Area End
